import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperclip16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPaperclip16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.39 3.476c-.24.316-.39.827-.39 1.571V10c0 .911.255 1.665.68 2.182.418.507 1.025.818 1.82.818s1.402-.311 1.82-.818c.425-.517.68-1.27.68-2.182V4.885h1V10c0 1.089-.305 2.085-.909 2.818C10.48 13.56 9.586 14 8.5 14s-1.979-.439-2.591-1.182C5.304 12.085 5 11.088 5 10V5.048c0-.854.17-1.615.591-2.174C6.031 2.29 6.691 2 7.5 2s1.469.29 1.909.874c.422.559.591 1.32.591 2.173V10c0 .531-.076 1.025-.318 1.398-.27.415-.693.602-1.182.602-.49 0-.912-.187-1.182-.602C7.076 11.025 7 10.53 7 10V5h1v5c0 .469.074.725.157.852.055.085.132.148.343.148s.288-.063.343-.148C8.926 10.725 9 10.47 9 10V5.047c0-.743-.151-1.255-.39-1.57C8.39 3.184 8.05 3 7.5 3s-.89.185-1.11.476m5.11.908a.5.5 0 0 1 .5.5h-1a.5.5 0 0 1 .5-.5m-4 .116A.5.5 0 0 1 8 5H7a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperclip16);
